import { $t } from "helpers/translator"

const ManageMyClinics = {
    steps: [
        {
            target: '#clinicsTableTitle',
            title: $t('global.tours.ManageMyClinics.0.title'),
            content: $t('global.tours.ManageMyClinics.0.content'),
        },
        {
            target: '#row-0 ',
            title: $t('global.tours.ManageMyClinics.1.title'),
            content: $t('global.tours.ManageMyClinics.1.content'),
            waitForElement: true,
        },
        {
            target: '#row-0 .clinicLink',
            title: $t('global.tours.ManageMyClinics.2.title'),
            content: $t('global.tours.ManageMyClinics.2.content'),
            locale: {
                last: $t('global.tours.ManageMyClinics.2.confirm')
            }
        }
    ],
    url: '/clinics'
}

export default ManageMyClinics